import { render, staticRenderFns } from "./SharePhotos.vue?vue&type=template&id=27c9e058&"
import script from "./SharePhotos.vue?vue&type=script&lang=js&"
export * from "./SharePhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports